<template>
	<section class="b360-grid-row preference-center-section">
		<div class="b360-col-xs-12 b360-col-sm-12 b360-col-md-6">
			<FormInputs
				name="addressLine1"
				ref="addressLine1"
				label="Address Line 1"
				type="text"
				placeholder="123 Main St"
				:maxLength="100"
				:required="true"
				:error="addressLine1Error"
				v-model="addressLine1"
				@blur="$v.address.addressLine1.$touch()"
				:disabled="roleIsNotActive('EditAPersonalAddressLine1')"
				data-test="addressLine1-input"
			/>
			<span class="error" v-if="addressLine1Error">Address is required.</span>
		</div>
		<FormInputs
			class="b360-col-xs-12 b360-col-sm-12 b360-col-md-6"
			name="addressLine2"
			ref="addressLine2"
			label="Address Line 2"
			type="text"
			placeholder="Suite 313"
			:value="address.addressLine2"
			v-model="addressLine2"
			:maxLength="100"
			:required="false"
			:disabled="roleIsNotActive('EditAPersonalAddressLine2')"
			data-test="addressLine2-input"
		/>
		<div class="b360-col-xs-12 b360-col-sm-12 b360-col-md-6">
			<FormInputs
				name="city"
				ref="city"
				label="City"
				type="text"
				placeholder="Anytown"
				:maxLength="50"
				v-model="city"
				:required="true"
				:disabled="roleIsNotActive('EditAPersonalCity')"
				@blur="$v.address.city.$touch()"
				:error="addressCityError"
				data-test="city-input"
			/>
			<span class="error" v-if="addressCityError">City is required.</span>
		</div>
		<div class="b360-col-xs-12 b360-col-sm-12 b360-col-md-6">
			<StateDropdown
				name="state"
				ref="state"
				label="State"
				type="text"
				placeholder="MI"
				v-model="state"
				:required="true"
				:disabled="roleIsNotActive('EditAPersonalState')"
				:error="addressStateError"
				@input="handleStateValue"
				data-test="state-drop-down"
			/>
			<span class="error" v-if="addressStateError">State is required.</span>
		</div>
		<div class="b360-col-xs-12 b360-col-sm-12 b360-col-md-6">
			<FormInputs
				name="zip"
				ref="zip"
				label="Zip Code"
				type="text"
				placeholder="12345"
				maxLength="5"
				v-model="zip"
				:required="true"
				:disabled="roleIsNotActive('EditAPersonalZipCode')"
				:error="addressZipError"
				@blur="$v.address.zip.$touch()"
				data-test="zip-input"
			/>
			<span class="error" v-if="addressZipError">Zip code is required.</span>
		</div>
	</section>
</template>
<script>
import StateDropdown from './StateDropdowns.vue';
import FormInputs from '@/components/global/FormInputs.vue';
import TitleDescription from '@/components/global/TitleDescription.vue';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import TextButton from '@/components/global/TextButton.vue';

export default {
	name: 'MailingAddress',
	components: {
		StateDropdown,
		FormInputs,
		TitleDescription,
		TextButton,
	},
	data() {
		return {
			localAddress: { ...this.address },
		};
	},
	props: {
		addressDisplayOrder: Number,
		addressIndex: Number,
		address: Object,
	},
	watch: {
		address(newVal) {
			this.localAddress = { ...newVal };
		},
	},
	computed: {
		...mapGetters(['roleIsNotActive']),
		addressLine1: {
			get() {
				return this.localAddress.addressLine1;
			},
			set(value) {
				this.localAddress.addressLine1 = value;
				this.addressUpdated();
			},
		},
		addressLine2: {
			get() {
				return this.localAddress.addressLine2;
			},
			set(value) {
				this.localAddress.addressLine2 = value;
				this.addressUpdated();
			},
		},
		city: {
			get() {
				return this.localAddress.city;
			},
			set(value) {
				this.localAddress.city = value;
				this.addressUpdated();
			},
		},
		state: {
			get() {
				return this.localAddress.state;
			},
			set(value) {
				this.localAddress.state = value;
				this.addressUpdated();
			},
		},
		zip: {
			get() {
				return this.localAddress.zip;
			},
			set(value) {
				this.localAddress.zip = value;
				this.addressUpdated();
			},
		},
		addressLine1Error() {
			return (
				!this.$v.address.addressLine1.required &&
				this.$v.address.addressLine1.$dirty
			);
		},
		addressCityError() {
			return !this.$v.address.city.required && this.$v.address.city.$dirty;
		},
		addressStateError() {
			return (
				this.address.state === '' &&
				!this.$v.address.state.required &&
				this.$v.address.state.$dirty
			);
		},
		addressZipError() {
			return !this.$v.address.zip.required && this.$v.address.zip.$dirty;
		},
	},
	validations: {
		address: {
			addressLine1: {
				required,
			},
			city: {
				required,
			},
			state: {
				required,
			},
			zip: {
				required,
			},
		},
	},
	methods: {
		handleStateValue(event) {
			this.localAddress.state = event.value;
			this.addressUpdated();
			this.$v.address.state.$touch();
		},
		addressUpdated() {
			this.$emit('updateAddress', {
				index: this.addressIndex,
				value: this.localAddress,
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.title-description {
	@for $i from 2 through 10 {
		&--span#{$i} {
			grid-row-end: span $i;
		}
	}
}
.error {
	color: $b360-color--red__error;
}
</style>
